import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import * as Yup from "yup";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import { FormGroup, Label, Button, UncontrolledPopover, PopoverHeader, PopoverBody, Modal, ModalHeader, ModalBody, Spinner, Card } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import { toast, ToastContainer } from "react-toastify";
import { useParams, useHistory } from "react-router-dom"; 
import {
    Icon,
    RSelect,
    Row,
    Col,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Block,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import LoadingSpinner from '../../../components/loader/Loader';

import DatePicker from "react-datepicker";
import DatePickerHeader from "./DatePickerHeader";

import {getInvoiceDetails, createNewInvoice, printInvoice, invoiceUpdateDetails, getDesignerMaster, updateInvoice, acceptTNC} from '../../../redux/uploadInvoice/action';
import moment from "moment";
import { toastStyles } from "../../../utils/Utils";
import { useForm, Controller } from "react-hook-form";

const UploadInvoice = ({ sizeList, inventoryData, productId, poType, designerId }) => {

    const history = useHistory();
    const { errors, handleSubmit, register, control, setValue, watch } = useForm();

    const queryString = window.location.search;		
    const urlParams = new URLSearchParams(queryString);
    const po_items = urlParams.get('po_items');
    const po_type = urlParams.get('po_type');     
    const invoice_id = urlParams.get('invoice_id');        
    const fc_id = urlParams.get('fc_id');        

    const getInvoiceDetailsCall = useMutation(getInvoiceDetails);
    const createNewInvoiceCall = useMutation(createNewInvoice);
    const printInvoiceCall = useMutation(printInvoice);
    const invoiceUpdateDetailsCall = useMutation(invoiceUpdateDetails);
    const getDesignerMasterCall = useMutation(getDesignerMaster);
    const updateInvoiceCall = useMutation(updateInvoice);    
    const acceptTNCCall = useMutation(acceptTNC);    
    
    
    
    const [selectedFC, setselectedFC] = useState({});
    const [FcId, setFcId] = useState(parseInt(fc_id));
    const [fcMasterList, setFcMasterList] = useState([]);
    const [invoiceDate, setinvoiceDate] = useState(new Date());    

    const [isAllowdInvoice, setIsAllowdInvoice] = useState();
    const [toc, setToc] = useState(false);

    const visitFormRef = useRef();

    const dispatch = useDispatch();
    const formClass = classNames({
        "form-validate": true,
        "is-alter": 'alter',
    });

    const [renderData, setRenderData] = useState({ rangeRates: [{ sr_no: '', aza_code: '', po_number: '', designer_code: '', quantity: 1, hsn_code: '', item_total_without_tax: '', igst_percentage: '', igst_value: '', sub_total: '', designer_id: '', opf_charges: '' }] });
    const [fromEdit, setFromEdit] = useState(true);
    const [invoiceSubTotal, setInvoiceSubTotal] = useState(0);
    const [invoiceTotal, setInvoiceTotal] = useState(0);
    const [invoiceTotalTax, setInvoiceTotalTax] = useState(0);
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [invoiceFileName, setInvoiceFileName] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [opfTotal,setOpfTotal] = useState(0);



    const handlePrintInvoice = (payload) => {
        printInvoiceCall.mutate(payload, {
            onSettled(data, error) {
            if (data) {               
                
                if(isAllowdInvoice !=1 ) {
                    window.open(data?.data?.s3_url, '_blank');    
                }                

                if(po_type == 'warehouse') {
                    history.push('/consignment-outright-po-listing');
                } else if(po_type == 'mto') {
                    history.push('/mto-po-listing');                    
                } else if(po_type == 'store') {
                    history.push('/store-po-listing');                    
                } else if(po_type == 'update') {
                    history.push('/generated-invoice-listing');                    
                }
                
            } else {
                console.log(error);     
                // toast.error(error.response.data.message, toastStyles)           
                toast.error('Print Invoice Error', toastStyles)           
            }
            }
        });
    }

    const onFormSubmit = () => {        
        if (visitFormRef.current)            
            visitFormRef.current.handleSubmit();
    }

    const onSubmit = (value) => {  

        if(isAllowdInvoice == null) {
            toast.info("Please select invoice option", toastStyles);
        } else {
                
            const values = value.rangeRates;
            var collect = [];

            for (var i = 0; i < values.length; i++) {
                collect.push({
                    // "sr_no": parseInt(values[i].sr_no),   
                    ...po_type == 'update' && { id: values[i].id },                                        
                    "aza_code": values[i].aza_code,
                    "po_number": `${values[i]?.po_number}`,                   
                    "quantity": 1,   
                    "unit_price": parseFloat(values[i].item_total_without_tax),
                    "tax_percent": parseInt(values[i].igst_percentage),
                    "tax": parseFloat(values[i].igst_value),                
                    "sub_total": parseFloat(values[i].sub_total),
                    "designer_id": renderData.rangeRates[i]?.designer_id,
                    "hsn_code": values[i]?.hsn_code,
                    "opf_charges": opfTotal,                                        
                })
            }

            let mtoType;

            if(invoiceDetails?.is_mto == 0) {
                mtoType = 'warehouse'
            } else if(invoiceDetails?.is_mto == 1) {
                mtoType = 'mto'
            } else if(invoiceDetails?.is_mto == 2) {
                mtoType = 'store'
            }            

            let payload = {            
                designer_invoice_url: invoiceFileName,            
                invoice_date: moment(invoiceDate).format('YYYY-MM-DD'),
                designer_invoice_no: value.designer_invoice_no,
                invoice_amount: invoiceTotal,            
                paid_amount: 0,
                fc_id: selectedFC?.id,
                invoice_type: po_type == 'update' ? mtoType : po_type,
                invoice_details: collect,
            }        

            // payload.is_aza_invoice = Number(!isAllowdInvoice) || 0;

            payload.is_aza_invoice = (isAllowdInvoice == 0 ? 1 : 0) || 0;

            if(po_type == 'update') {
                updateInvoiceCall.mutate({payload, invoice_id}, {
                    onSettled(data, error) {
                    if (data) {                                               
                        handlePrintInvoice(invoice_id)
                        toast.success(data.message, toastStyles);
                    } else {
                        toast.error(error.response.data.message, toastStyles);
                        console.log(error);                
                    }
                    }
                });
            } else {
                
                createNewInvoiceCall.mutate(payload, {
                    onSettled(data, error) {
                    if (data) {                                               
                        handlePrintInvoice(data?.data?.invoice_id)
                        toast.success(data.message, toastStyles);
                    } else {
                        toast.error(error.response.data.message, toastStyles);
                        console.log(error);                
                    }
                    }
                });
            } 
        }       
    }



    const setupDetails = (data) => {        
        // setRenderData({ rangeRates: data });
                      
        const subTotal = data?.reduce((total, item) => {
            return total + parseFloat(item?.item_total_without_tax)
        }, 0);        
        setInvoiceSubTotal(subTotal);

        const total = data?.reduce((total, item) => {
            return total + item?.sub_total
        }, 0);                            
        setInvoiceTotal(total);

        const totalTax = data?.reduce((total, item) => {
            return total + parseFloat(item?.igst_value)
        }, 0);                            
        setInvoiceTotalTax(totalTax);
    }

    const getFCs = () => {
        getDesignerMasterCall.mutate({}, {
            onSettled(data, error) {
                if (data) {                                                   
                    let tempArr = data?.data?.filter((item, i) => item?.is_store == 0);
                    setFcMasterList(tempArr);
                } else {
                    console.log(error);                
                }
            }
        });
    }
    

    const callInitDetails = () => {
        let payload = {
            po_data: po_items.split(','),
            po_type: po_type,
            fc_id: FcId,
        }

        getInvoiceDetailsCall.mutate(payload, { 
            onSettled(data, error) {
                if (data) {               
                    setInvoiceDetails(data?.data?.data);
                    setupDetails(data?.data?.data?.line_items);    
                    setRenderData({designer_invoice_url: invoiceFileName, designer_invoice_no: invoiceNumber, rangeRates: data?.data?.data?.line_items });
                    setOpfTotal(data?.data?.data?.invoice_summary?.total_opf_charges);
                    getFCs();               
                } else {
                    toast.error(error.response.data.message, toastStyles);
                    console.log(error);                
                }
            }
        });
    }

	useEffect(() => {			
        if(po_items) {       
            callInitDetails();
        } else if(po_type == 'update') {                        
            invoiceUpdateDetailsCall.mutate({invoice_id, FcId}, { 
                onSettled(data, error) {
                    if (data) {                                
                        setInvoiceDetails(data?.data);
                        setupDetails(data?.data?.invoice_details);     
                        setRenderData({ designer_invoice_url: data?.data?.designer_invoice_url, designer_invoice_no: data?.data?.designer_invoice_no,  rangeRates: data?.data?.invoice_details });
                        setInvoiceFileName(data?.data?.designer_invoice_url);                        

                        setinvoiceDate(moment(data?.data?.invoice_date)?._d)       
                        setIsAllowdInvoice(Number(!data?.data?.is_aza_invoice))                   

                        getFCs();               
                    } else {
                        console.log(error);                
                    }
                }
            });
        }
	}, [FcId]);

    useEffect(() => {
        const item = fcMasterList.filter(option => option.id == invoiceDetails?.fc_id || option.id == invoiceDetails?.aza_fc_id);        
        setselectedFC(item[0]);
    }, [fcMasterList]);


    const saveFile = async (params) => {
        try {
            const { data } = await loginAxios.post(`payment/upload-invoice`, params.formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const saveFileCall = useMutation(saveFile);

    const handleFileSave = (e, type) => {
        let formData = new FormData();

        let maxSize = 5;
        const file = e.target.files[0];
        if (((file.size / 1024) / 1000) < maxSize) {

            formData.append("file", file);    
            formData.append("type", type);            
            var payload = {
                formData                
            }
            saveFileCall.mutate(payload, {
                onSettled(data, error) {
                    if (data) {                        
                        setInvoiceFileName(data?.data?.file_path)                        
                    } else if (error) { }
                }
            });
        } else {
            toast.info("Please upload file less than 5 MB", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });
        }

    }

    const regularValidation = Yup.object({                                
        designer_invoice_no: Yup.string().required('This field is required.'),
        designer_invoice_url: Yup.mixed().required('This field is required.'),
        rangeRates: Yup.array().of(
            Yup.object().shape({                                        
                // aza_code: Yup.string()
                //     .required('This field is required'),
                // designer_code: Yup.string()
                // .required('This field is required'),
                hsn_code: Yup.string()
                .required('This field is required')
                .max(8, "Not more than 8 characters allowed."),                                        
                igst_percentage: Yup.string()
                    .required('This field is required')
                    .matches(/^(?:0|[1-9]?[0-9])(?:\.[0-9]+)?$/, 'Numbers between 1-99 only'),                                        
            })
        )
    });


    const conditionValidation = Yup.object({                                
        // designer_invoice_no: Yup.string().required('This field is required.'),
        // designer_invoice_url: Yup.mixed().required('This field is required.'),
        rangeRates: Yup.array().of(
            Yup.object().shape({                                        
                // aza_code: Yup.string()
                //     .required('This field is required'),
                // designer_code: Yup.string()
                // .required('This field is required'),
                hsn_code: Yup.string()
                .required('This field is required')
                .max(8, "Not more than 8 characters allowed."),                                        
                igst_percentage: Yup.string()
                    .required('This field is required')
                    .matches(/^(?:0|[1-9]?[0-9])(?:\.[0-9]+)?$/, 'Numbers between 1-99 only'),                                        
            })
        )
    });


    useEffect(() => {
        if(isAllowdInvoice == 0 && invoiceDetails?.is_tnc_accepted == 0) {            
            toggleLg();
        }
    }, [isAllowdInvoice, invoiceDetails]);



    const [modalLg, setModalLg] = useState(false);
    const toggleLg = () => setModalLg(!modalLg);

    const handleTermsButton = () => {        

        let payload = {
            is_tnc_accepted:1,
            signature_image_url: invoiceFileName
        }        

        acceptTNCCall.mutate(payload, {
            onSettled(data, error) {
                if (data) {  
                    callInitDetails();                      
                    setInvoiceFileName("");
                    toggleLg();                        
                } else if (error) { }
            }
        });
    }


    const handleRemoveItem = (e, index) => {
        e.preventDefault();
        const tempData = {...renderData};
        let tempArr = tempData.rangeRates;        
        tempArr.splice(index, 1);        
        tempData.rangeRates = tempArr;
        setRenderData(tempData);
        setupDetails(tempArr)
    }

    return (<>

        <Content>
        {(getInvoiceDetailsCall?.isLoading || printInvoiceCall?.isLoading || invoiceUpdateDetailsCall?.isLoading) && <LoadingSpinner />}

            <BlockHead size="sm" className="mt-4">
                <BlockBetween>
                    <BlockHeadContent>
                        <h6 className="title">Invoice Generation</h6>                        
                    </BlockHeadContent>                    
                </BlockBetween>
            </BlockHead>

            <Block>

                <Card className="card-stretch p-4">                    

                    <div className="form-block">
                        <Formik
                            enableReinitialize={true}
                            initialValues={renderData}
                            validationSchema={isAllowdInvoice == 1 ? regularValidation : conditionValidation}
                            innerRef={visitFormRef}
                            onSubmit={(value) => { onSubmit(value) }}

                        >
                            {props => {
                                const { handleChange, values, errors, touched, handleSubmit, resetForm, setFieldValue } = props;
                                return (
                                    <>
                                        <Form className={formClass}>

                                            {invoiceDetails?.allow_aza_invoices == 1 && <Row className="mb-4">                                                           
                                                <Col md="12">
                                                    <Label className="form-label mr-2">Choose Your Invoice Option*</Label>
                                                    <div className="custom-control custom-radio mr-2 mb-1">
                                                        <input
                                                            ref={register({ required: true })}
                                                            type="radio"
                                                            className="form-control custom-control-input"
                                                            id={"allowInvoiceYes"}
                                                            name="allow_aza_invoices"
                                                            checked={isAllowdInvoice ? true : false}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setIsAllowdInvoice(1)
                                                                }
                                                            }}
                                                            disabled={po_type == 'update' ? true : false}
                                                            // defaultValue={isAllowdInvoice}                                
                                                        />
                                                        <Label className="custom-control-label" htmlFor={"allowInvoiceYes"}>
                                                            Upload Your Own Invoice
                                                        </Label>
                                                    </div>

                                                    <div className="custom-control custom-radio">
                                                        <input
                                                            ref={register({ required: true })}
                                                            type="radio"
                                                            className="form-control custom-control-input"
                                                            id={"allowInvoiceNo"}
                                                            name="allow_aza_invoices"
                                                            checked={isAllowdInvoice == false && true}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setIsAllowdInvoice(0)
                                                                }
                                                            }}
                                                            disabled={po_type == 'update' ? true : false}
                                                            // defaultValue={isAllowdInvoice}                                
                                                        />
                                                        <Label className="custom-control-label" htmlFor={"allowInvoiceNo"}>
                                                            Use Platform-generated Invoice 
                                                        </Label>
                                                    </div>
                                                    {errors.isAllowdInvoice && <span className="invalid">This field is required</span>}
                                                </Col>
                                            </Row> }
                                            
                                            <Row className="mb-4">
                                                {(invoiceDetails?.allow_aza_invoices == 0 || isAllowdInvoice == 1) && <Col sm="6">                                                 
                                                     <FormGroup>
                                                            <Label className="form-label" htmlFor="designer_invoice_url">
                                                                Invoice Upload*
                                                            </Label>
                                                            <div className="form-control-wrap">                            
                                                                <input
                                                                    type="file"
                                                                    className="custom-file-input form-control"
                                                                    id="designer_invoice_url"
                                                                    name="designer_invoice_url"                                                                
                                                                    onChange={(e) => {
                                                                        handleFileSave(e, 'designer_invoice');
                                                                        setFieldValue('designer_invoice_url', e.currentTarget.files[0]);
                                                                    }}
                                                                    // accept="application/pdf,application/vnd.ms-excel"
                                                                    accept=".doc,.docx,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                                // disabled={!isEdit}
                                                                />
                                                                <label className="custom-file-label" htmlFor="designer_invoice_url">
                                                                    {invoiceFileName == "" ? "Choose files" : invoiceFileName}
                                                                </label>

                                                                {errors.designer_invoice_url && <span className="invalid">This field is required</span>}
                                                            </div>
                                                        </FormGroup>                                                                                                                                                    
                                                    </Col>
                                                }
                                                <Col sm="6">

                                                <FormGroup>
                                                        <Label className="form-label" htmlFor="invoice_date">
                                                            Invoice Date*
                                                        </Label>
                                              
                                              
                                                        <DatePicker
                                                        id="datePicker"
                                                        dateFormat="yyyy-MM-dd"
                                                        autoComplete="off"
                                                        wrapperClassName="end-m"
                                                        // minDate={new Date()}
                                                        className="form-control"                                                        
                                                        onKeyDown={(e) => e.preventDefault()}
                                                        selected={invoiceDate}
                                                        onChange={val => {                                                            
                                                            // onChange(val);                                    
                                                            setinvoiceDate(val);
                                                        }}
                                                        onFocus={e => e.target.blur()}
                                                        renderCustomHeader={({
                                                            date,
                                                            changeYear,
                                                            changeMonth,
                                                            decreaseMonth,
                                                            increaseMonth,
                                                            prevMonthButtonDisabled,
                                                            nextMonthButtonDisabled,
                                                        }) => {
                                                            return (
                                                                <DatePickerHeader
                                                                    date={date}
                                                                    changeYear={changeYear}
                                                                    changeMonth={changeMonth}
                                                                    decreaseMonth={decreaseMonth}
                                                                    increaseMonth={increaseMonth}
                                                                    prevMonthButtonDisabled={prevMonthButtonDisabled}
                                                                    nextMonthButtonDisabled={nextMonthButtonDisabled}
                                                                />
                                                            );
                                                        }}
                                                    />

                                                    </FormGroup>


                                                </Col>
                                                <Col sm="6">


                                                    <FormGroup>
                                                        <Label className="form-label" htmlFor="designer_invoice_no">
                                                            Invoice No.{isAllowdInvoice == 1 ? '*' : ''}
                                                        </Label>
                                                        <div className="form-control-wrap">
                                                            <input
                                                                type="text"
                                                                id="designer_invoice_no"
                                                                name="designer_invoice_no"
                                                                defaultValue={values.designer_invoice_no}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    setInvoiceNumber(e.target.value);
                                                                }}
                                                                // onBlur={handleBlur}
                                                                className="form-control"
                                                            />
                                                            {isAllowdInvoice == 1 && errors.designer_invoice_no && <span className="invalid">This field is required</span>}
                                                        </div>
                                                    </FormGroup>

                                                </Col>
                                            </Row>





                                            <Row>
                                                <Col md="4">
                                                                                            
                                                    <div className="invoice-head">
                                                    <div className="invoice-contact">
                                                        <span className="overline-title">From</span>
                                                        <div className="invoice-contact-info">
                                                        <h4 className="title">{invoiceDetails?.designer_company_name || invoiceDetails?.designer_name}</h4>
                                                        <ul className="list-plain">
                                                            <li>
                                                            {/* <Icon name="map-pin-fill"></Icon> */}
                                                            <span>
                                                                {invoiceDetails?.designer_address}    <br/>
                                                                {invoiceDetails?.designer_pincode},&nbsp; 
                                                                {invoiceDetails?.designer_city},&nbsp;
                                                                {invoiceDetails?.designer_state}                                                            
                                                            </span>
                                                            </li>
                                                            <li>
                                                            <Icon name="call-fill"></Icon>
                                                            <span>{invoiceDetails?.designer_phone}</span>
                                                            </li>
   <li>
                                                            <Icon name="mail"></Icon>
                                                            <span>{invoiceDetails?.designer_email}</span>
                                                            </li>
                                                            <li>                                                                                                                    
                                                            <span>
                                                                GST No.: {invoiceDetails?.designer_gst_no}
                                                            </span>
                                                            </li>
                                                        </ul>
                                                        </div>
                                                    </div>                                                    
                                                    </div>
                                                </Col>

                                                <Col md="4"></Col>

                                                <Col md="4">
                                                                                            
                                                    <div className="invoice-head">
                                                    <div className="invoice-contact">
                                                        <span className="overline-title">To</span>

                                                        <FormGroup>
                                                            {/* <Label className="form-label" htmlFor="merchandiser-name1">
                                                                change FC
                                                            </Label> */}

                                                            <Controller
                                                                control={control}
                                                                name="merchandisername1"
                                                                render={({ onChange, value, name, ref }) => (
                                                                    <RSelect
                                                                        inputRef={ref}
                                                                        classNamePrefix="addl-class"
                                                                        options={fcMasterList}
                                                                        getOptionLabel={(option) => option?.fc_location}
                                                                        getOptionValue={(option) => option?.id}
                                                                        value={selectedFC}
                                                                        isSearchable={false}
                                                                        // value={
                                                                        //     fcMasterList.filter(option =>
                                                                        //         option.value == selectedFC)
                                                                        // }
                                                                        onChange={val => {
                                                                            setselectedFC(val);                                                                            
                                                                            setFcId(val?.id);
                                                                            onChange(val);
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </FormGroup>

                                                        <div className="invoice-contact-info">
                                                        <h4 className="title">{selectedFC?.fc_location}</h4>
                                                        <ul className="list-plain">
                                                            <li>
                                                            {/* <Icon name="map-pin-fill"></Icon> */}
                                                            <span>                                                                
                                                                {selectedFC?.address_line_one},
                                                                {selectedFC?.address_line_two}    <br/>

                                                                {selectedFC?.pin_code},&nbsp; 
                                                                {selectedFC?.city},&nbsp; 
                                                                {selectedFC?.state_name}
                                                            </span>
                                                            </li>
                                                                                                                            
                                                            <li>
                                                            <Icon name="call-fill"></Icon>
                                                            <span>{selectedFC?.contact_no}</span>
                                                            </li>

                                                            {/* <li>  
                                                            <Icon name="mail"></Icon>                                                          
                                                            <span>
                                                                {selectedFC?.email}
                                                            </span>
                                                            </li> */}
                                                            <li>                                                            
                                                            <span>
                                                                GST No.: {selectedFC?.gst_no}
                                                            </span>
                                                            </li>
                                                        </ul>
                                                        </div>
                                                    </div>                                                    
                                                    </div>
                                                </Col>
                                            </Row>



                                            <fieldset>
                                                <FieldArray
                                                    name="rangeRates"
                                                    render={arrayHelpers => {
                                                        var rangeRates = values.rangeRates;
                                                        return (
                                                            <Row className="g-gs table-scroll">
                                                                <Col md="12">
                                                                    <table className="invoice-item-table mt-4">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col">Line No.</th>
                                                                                {/* <th scope="col">Azacode</th> */}
                                                                                {(po_type == 'warehouse' || po_type == 'store') && <th scope="col">Barcode</th>}
                                                                                {(po_type == 'mto' || po_type == "update") && <th scope="col">PO Number</th>}
                                                                                <th scope="col">Designer Code</th>
                                                                                <th scope="col">Qty.</th>
                                                                                <th scope="col">HSN Code</th>
                                                                                <th scope="col">Unit Price</th>
                                                                                {!invoiceDetails?.is_igst && <th scope="col">SGST %</th>}
                                                                                {!invoiceDetails?.is_igst && <th scope="col">CGST %</th>}
                                                                                {/* <th scope="col">OPF Charges</th> */}
                                                                                
                                                                                {!invoiceDetails?.is_igst ? <th scope="col">Total Tax</th> : <th scope="col">Tax (IGST %)</th>}
                                                                                                                                                                
                                                                                <th scope="col">Sub Total</th>

                                                                                {!fromEdit &&
                                                                                    <th>
                                                                                        <span className="btn btn-outline-success"
                                                                                            onClick={() =>
                                                                                                arrayHelpers.push({
                                                                                                    sr_no: "",
                                                                                                    aza_code: "",
                                                                                                    po_number: "",
                                                                                                    designer_code: "",
                                                                                                    quantity: "",
                                                                                                    hsn_code: "",
                                                                                                    item_total_without_tax: "",
                                                                                                    igst_percentage: 0,
                                                                                                    igst_value: 0,
                                                                                                    sub_total: ''
                                                                                                })
                                                                                            }
                                                                                        >
                                                                                            +
                                                                                        </span>
                                                                                    </th>
                                                                                }

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {rangeRates && rangeRates?.length > 0
                                                                                ? rangeRates?.map((record, index) => (
                                                                                    <tr key={index}>

                                                                                        <td>
                                                                                            {index+1}
                                                                                            {/* {values.rangeRates[index].sr_no} */}
                                                                                        </td>

                                                                                        {/* <td>
                                                                                            <Field
                                                                                                placeholder="azacode"
                                                                                                name={`rangeRates.${index}.aza_code`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                            />
                                                                                            <ErrorMessage name={`rangeRates.${index}.aza_code`} render={msg => <span className="invalid">{msg}</span>} />
                                                                                        </td> */}

                                                                                        {(po_type == 'warehouse' || po_type == 'store') && <td>
                                                                                            <Field
                                                                                                placeholder="azacode"
                                                                                                name={`rangeRates.${index}.aza_code`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                            />
                                                                                            <ErrorMessage name={`rangeRates.${index}.aza_code`} render={msg => <span className="invalid">{msg}</span>} />
                                                                                        </td>
                                                                                        }
                                                                                {(po_type == 'mto' || po_type == "update") && <td>
                                                                                            <Field
                                                                                                placeholder="po number"
                                                                                                name={`rangeRates.${index}.po_number`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                            />
                                                                                            <ErrorMessage name={`rangeRates.${index}.po_number`} render={msg => <span className="invalid">{msg}</span>} />
                                                                                        </td>}

                                                                                        <td>
                                                                                            <Field
                                                                                                placeholder="designer_code"
                                                                                                name={`rangeRates.${index}.designer_code`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                            />
                                                                                            <ErrorMessage name={`rangeRates.${index}.designer_code`} render={msg => <span className="invalid">{msg}</span>} />
                                                                                        </td>

                                                                                        <td>
                                                                                            <Field
                                                                                                placeholder="Quantity"
                                                                                                name={`rangeRates.${index}.quantity`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                                value="1"
                                                                                            />                        
                                                                                        </td>

                                                                                        <td valign="top" style={{top: '4px'}}>
                                                                                            <Field
                                                                                                placeholder="hsn_code"
                                                                                                name={`rangeRates.${index}.hsn_code`}
                                                                                                className="form-control form-control-sm hsn-code"
                                                                                                type="text"
                                                                                                // disabled                                                       
                                                                                            />
                                                                                            <ErrorMessage name={`rangeRates.${index}.hsn_code`} render={msg => <span className="invalid">{msg}</span>} />                        
                                                                                        </td>
                                                                                        
                                                                                        <td>
                                                                                            <Field
                                                                                                placeholder="Unit Price" 
                                                                                                name={`rangeRates.${index}.item_total_without_tax`}
                                                                                                className="form-control form-control-sm unit-price"
                                                                                                type="number"
                                                                                                disabled
                                                                                            />
                                                                                        </td>

                                                                                        {!invoiceDetails?.is_igst && <td>
                                                                                            <Field
                                                                                                placeholder="SGST"
                                                                                                name={`rangeRates.${index}.sgst_percentage`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                            />
                                                                                            <span className="igst-tax-value">({values.rangeRates[index].sgst_value || 0})</span>
                                                                                        </td>}

                                                                                        {!invoiceDetails?.is_igst && <td>
                                                                                            <Field
                                                                                                placeholder="CGST"
                                                                                                name={`rangeRates.${index}.cgst_percentage`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"
                                                                                                disabled
                                                                                            />
                                                                                            <span className="igst-tax-value">({values.rangeRates[index].cgst_value || 0})</span>
                                                                                        </td>}

                                                                                        {/* <td>
                                                                                            <Field
                                                                                                placeholder="OPF Charges"
                                                                                                name={`rangeRates.${index}.opf_charges`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="number"
                                                                                                disabled
                                                                                            />
                                                                                        </td> */}
                                                                                        
                                                                                        <td valign="top" style={{top: '4px'}}>
                                                                                            <Field
                                                                                                placeholder="Tax Percentage"
                                                                                                name={`rangeRates.${index}.igst_percentage`}
                                                                                                className="form-control form-control-sm igst-percent"     
                                                                                                type="text"    
                                                                                                disabled={invoiceDetails?.gst_registered == 0}
                                                                                                onChange={(e) => {
                                                                                                    handleChange(e);
                                                                                                    if (/^(?:0|[1-9]?[0-9])(?:\.[0-9]+)?$/.test(e.target.value)) {
                                                                                                        var elem = values.rangeRates[index];
                                                                                                        let newValue = (elem?.sub_total/((1+ Number(e.target.value)/100))).toFixed(2);
                                                                                                        setFieldValue(`rangeRates.${index}.item_total_without_tax`, isNaN(elem?.item_total_without_tax) ? elem?.item_total_without_tax : newValue, false);
                                                                                                        let calcValue = (Number(invoiceSubTotal)-Number(elem?.item_total_without_tax)) + Number(newValue)                                                                                                        
                                                                                                        setInvoiceSubTotal(calcValue.toFixed(2));
                                                                                                        let percentValue = (Number(elem?.sub_total) - Number(newValue)).toFixed(2)
                                                                                                        setFieldValue(`rangeRates.${index}.igst_value`, percentValue, false);
                                                                                                        if(!invoiceDetails?.is_igst) {
                                                                                                            setFieldValue(`rangeRates.${index}.sgst_percentage`, e.target.value/2, false);
                                                                                                            setFieldValue(`rangeRates.${index}.cgst_percentage`, e.target.value/2, false);
                                                                                                            setFieldValue(`rangeRates.${index}.sgst_value`, percentValue/2, false);
                                                                                                            setFieldValue(`rangeRates.${index}.cgst_value`, percentValue/2, false);
                                                                                                        }
                                                                                                        let calcValuePercent = (Number(invoiceTotalTax)-Number(elem?.igst_value)) + Number(percentValue)                                                                                                        
                                                                                                        setInvoiceTotalTax(calcValuePercent.toFixed(2));
                                                                                                    }                                                                                                                                                                                                        
                                                                                                }}                                                                                            
                                                                                            />

                                                                                            {/* <span>{values.rangeRates[index].igst_percentage || 0} %</span> <br/> */}
                                                                                            <span className="igst-tax-value">({values.rangeRates[index].igst_value || 0})</span>

                                                                                            <ErrorMessage name={`rangeRates.${index}.igst_percentage`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                        </td>
                                                                                        
                                                                                        <td>
                                                                                            <Field
                                                                                                placeholder="Sub Total"
                                                                                                name={`rangeRates.${index}.sub_total`}
                                                                                                className="form-control form-control-sm"
                                                                                                type="text"   
                                                                                                disabled                                                                                             
                                                                                            />

                                                                                            <ErrorMessage name={`rangeRates.${index}.sub_total`} render={msg => <span className="invalid">{msg}</span>} />

                                                                                        </td>

                                                                                        {po_type == 'update' && renderData?.rangeRates?.length > 1 && <td>
                                                                                            <Button className="btn btn-icon btn-primary" onClick={(e) =>  handleRemoveItem(e, index)}>
                                                                                                <Icon name="trash"></Icon>
                                                                                            </Button>
                                                                                        </td> }
                                                                                        

                                                                                    </tr>
                                                                                ))
                                                                                : null}
                                                                        </tbody>
                                                                    </table>
                                                                </Col>
                                                            </Row>
                                                        );
                                                    }}
                                                />
                                            </fieldset>

                                            <Row>
                                                <Col md="8">
                                                </Col>
                                                <Col md="4">
                                         

                                            <div className="mt-5">
                                                <h5 style={{float: 'left'}}>Invoice Summary</h5>
                                                <table className="table" style={{marginLeft: '-1.25rem'}}>
                                                {/* table-striped */}
                                                    <thead>
                                                        <tr>
                                                        <th className="">Total Before Tax</th>
                                                        <th align="right" className="text-right">{Number(invoiceSubTotal)?.toFixed(2)}</th>
                                                        
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                        <td>Total Tax</td>
                                                        <td align="right">{Number(invoiceTotalTax)?.toFixed(2)}</td>                         
                                                        </tr>    

                                                         {/* <tr>
                                                        <td>Total OPF Charges</td>
                                                        <td align="right">{Number(opfTotal)?.toFixed(2)}</td>                         
                                                        </tr>                                                       */}

                                                        <tr>
                                                        <td>Total Amount After Tax</td>
                                                        <td align="right">{Number(invoiceTotal)?.toFixed(2)}</td>                         
                                                        </tr>
                                                        
                                                        </tbody>
                                                        </table>
                                                    
                                                    
                                                    
                                                    
                                                </div>
                                            </Col>
                                            </Row>

                                            <Button color="primary" className="ml-2 mt-2" onClick={onFormSubmit} disabled={createNewInvoiceCall.isLoading ? true : false}>                                                
                                                
                                                {createNewInvoiceCall.isLoading ? <Spinner color="light" size='sm' />: <Icon name="save" />} <span>Save</span>
                                            </Button>

                                        </Form>
                                    </>
                                );
                            }}
                        </Formik>
                    </div>

                </Card>

            </Block>
        </Content>

        
        <Modal size="lg" 
        isOpen={modalLg}     
        backdrop={'static'}   
        keyboard={false}
         toggle={toggleLg}>
                        <ModalHeader
                            
                            // toggle={toggleLg}
                            // close={
                            //     <button className="close" onClick={toggleLg}>
                            //         <Icon name="cross" />
                            //     </button>
                            // }
                        >
                            TERMS AND CONDITIONS
                        </ModalHeader>
                        <ModalBody>

                            <div style={{height: '400px', overflowY: 'scroll', overflowX: 'hidden'}}>

                            <p>The Portal is provided to facilitate the generation, management and tracking of invoices related to B2C orders placed through www.azafashions.com or Aza mobile application.
                            </p>
                            
                            
                            <h5>1.  Issuance of Invoices </h5>
                            <p>1.1. The Designer expressly agrees that issuing correct and complete invoices is their sole and primary responsibility.
                                <br />
                                1.2. The Company will provide the Designer the facility to generate invoices on the portal, for which a digital image of the signature of the Designer or its authorised signatory is required. This signature will be affixed to the generated invoices.
                                <br />
                                1.3. The submitted invoices required to be downloaded by the Designer.
                            </p>
                            
                            <h5>2.  Invoice Submission and Payment </h5>
                            <p>2.1. Invoices must be submitted through the Portal within the stipulated time frame as per the agreed terms.
                                <br />
                                2.2. The Company will process the invoices submitted through the Portal in accordance with the agreed payment terms.
                                <br />
                                2.3. The Company reserves the right to withhold payment or reject invoices that do not comply with the agreed terms or applicable laws.<br />
                                2.4. Payments will be made to the Designer's registered bank account, and the Designer is responsible for ensuring that their bank details are accurate and up to date.
                            </p>

                            
                            <h5>3.  Liability for Invoice Discrepancies </h5>
                            <p>3.1. The Designer acknowledges that they are solely liable for any discrepancies or liabilities that may be imposed by taxation authorities due to incorrect or incomplete invoices.
                                <br />
                                3.2. Any mismatch between the invoice generated by the Designer and the details submitted by the Designer to the GST portal will result in the recovery of the discrepancy amount from the Designer by the Company.
                                <br />
                                3.3. If discrepancies continues for more than 2 months, designer rights to use the Designer panel format invoice will be revoked and past discrepancies dues paid by company will be recoverable from designer.<br />
                     
                            </p>
                            
                            <h5>4.  Compliance with Laws </h5>
                            <p>4.1. The Designer agrees to comply with all applicable laws, regulations, and tax obligations in relation to the submission of invoices and receipt of payments.
                                <br />
                               4.2. The Designer shall be solely responsible for the payment of all applicable taxes related to the invoices submitted through the Portal.
                                <br />
                     
                            </p>


                            
                            <h5>5.  Confidentiality </h5>
                            <p>5.1. The Designer agrees to keep confidential all information obtained through the Portal, including but not limited to pricing, transaction details, and other proprietary information of the Company.
                                <br />
                               5.2. The Designer shall not disclose any confidential information to third parties without the prior written consent of the Company.
                                <br />
                     
                            </p>


                            
                            <h5>6.  Data Protection and Privacy </h5>
                            <p>6.1. The Company will handle Designer data in accordance with its Privacy Policy, which is available on the www.azafashions.com .
                                <br />
                               6.2. The Designer consents to the collection, use, and processing of their personal and business information as outlined in the Privacy Policy.
                                <br />
                     
                            </p>

                            
                            <h5>7.  Dispute Resolution  </h5>
                            <p>7.1. These Terms shall be governed by and construed in accordance with the laws of India.
                                <br />
                               7.2. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Mumbai, India.
                                <br />
                     
                            </p>

                            <div className="custom-control custom-checkbox">
                                    <input                                        
                                        type="checkbox"
                                        className="form-control custom-control-input"
                                        onChange={(e) => setToc(e.target.checked)}
                                        id={"TOC"}
                                        name="TOC"                                        
                                    />
                                    <Label className="custom-control-label" htmlFor={"TOC"}>
                                        I have read and agreed to the terms and conditions.
                                    </Label>
                                 
                                </div>
                            
                            <Row className="mb-2 mt-4">
                                <Col md="4">                                                 
                                        <FormGroup>
                                            <Label className="form-label" htmlFor="designer_invoice_url">
                                                Upload Signature
                                            </Label>
                                            <div className="form-control-wrap">                            
                                                <input
                                                    type="file"
                                                    className="custom-file-input form-control"
                                                    id="designer_invoice_url"
                                                    name="designer_invoice_url"                                                                
                                                    onChange={(e) => {
                                                        handleFileSave(e, 'signature');                                                        
                                                    }}                                                                                                        
                                                    accept=".png, .jpg, .jpeg"
                                                
                                                />
                                                <label className="custom-file-label" htmlFor="designer_invoice_url">
                                                    {invoiceFileName == "" ? "Choose files" : invoiceFileName}
                                                </label>

                                                {/* {errors.designer_invoice_url && <span className="invalid">This field is required</span>} */}
                                            </div>
                                        </FormGroup>                                                                                                                                                    
                                    </Col>
                                    <Col md="8">
                                        <img width='100px' src="/Signature.jpg" />
                                        <p>Please ensure your signature & stamp is clearly visible and upload the cropped image.</p>
                                    </Col>
                            </Row>
                            <Button color="primary" className="mt-2" 
                                onClick={handleTermsButton} 
                                disabled={( toc == false || invoiceFileName == "" || acceptTNCCall?.isLoading) ? true : false}
                            >                                                
                                {acceptTNCCall?.isLoading ? <Spinner color="light" size='sm' />: <Icon name="save" />} <span>Submit</span>                                
                            </Button>

                            </div>
                        </ModalBody>
                    </Modal>
        <ToastContainer/>

    </>)
};

export default UploadInvoice;